import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import Icon from '@/assets/images/icon/icon_banner_consulting.svg';

/**
 * // TODO:
 * 전문가 문의 플로팅 메뉴
 * 임시 처리로 추후 변경 가능
 */
const FloatingBanner = () => {
	// const [position, setPosition] = useState<'fixed' | 'absolute'>('fixed');
	// const [bottom, setBottom] = useState(40);

	// useEffect(() => {
	// 	const handleFloating = () => {
	// 		const scrollY = window.scrollY;
	// 		const footer = document.querySelector('footer');

	// 		if (!footer) return;

	// 		const footerOffsetTop = footer.offsetTop;
	// 		const footerHeight = footer.offsetHeight;

	// 		if (scrollY + window.innerHeight >= footerOffsetTop) {
	// 			setPosition('absolute');
	// 			setBottom(footerHeight + 40);
	// 		} else {
	// 			setPosition('fixed');
	// 			setBottom(40);
	// 		}
	// 	};

	// 	window.addEventListener('scroll', handleFloating);
	// 	return () => window.removeEventListener('scroll', handleFloating);
	// }, []);

	return (
		<div className="floating-banner">
			<Link to={NAV_PATH.CONSULTING}>
				<i className="icon">
					<img src={Icon} alt="Stella logo" />
				</i>
				전문가 문의
			</Link>
		</div>
	);
};

export default FloatingBanner;
